module.exports = {
  formatDateTime(isoDateTime = "", model) {
    isoDateTime = isoDateTime.replace("T", " ");

    const dateTimeContent = isoDateTime.split(" ");

    const date = dateTimeContent[0];
    const time = dateTimeContent[1];

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    if (date) {
      const dateContent = date.split("-");

      year = dateContent[0];
      month = dateContent[1];
      day = dateContent[2];
    }

    if (time) {
      const timeContent = time.split(":");

      hours = timeContent[0];
      minutes = timeContent[1];
      seconds = timeContent[2];
    }

    return model
      .replace("Y", year)
      .replace("M", month)
      .replace("D", day)
      .replace("h", hours)
      .replace("m", minutes)
      .replace("s", seconds);
  },

  formatarTempo(minutos = 0) {
    let horas = 0;
    let dias = 0;

    if (minutos < 60)
      return `${minutos}${minutos > 1 ? " minutos " : " minuto "}`;

    horas = parseInt(minutos / 60);
    minutos = minutos % 60;

    if (horas < 24)
      return `${horas}${horas > 1 ? " horas " : " hora "}${minutos}${
        minutos > 1 ? " minutos " : " minuto "
      }`;

    dias = parseInt(horas / 24);
    horas = horas % 24;

    return `${dias}${dias > 1 ? " dias " : " dia "}${horas}${
      horas > 1 ? " horas " : " hora "
    }${minutos}${minutos > 1 ? " minutos " : " minuto "}`;
  },
};
